exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messages a.h6 {\r\n    margin-right: 5px;\r\n    font-size: 0.79rem !important;\r\n}\r\n.delete-button{\r\n    float: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/messages/messages.component.css
// module id = ../../../../../src/app/messages/messages.component.css
// module chunks = main